<template>
  <div class="container">
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>
    <b-form v-show="!loading">
      <b-row>
        <!-- İşletme Bilgileri -->
        <b-col class="col-12">
          <b-card header="İşletme Bilgileri" class="mb-3 bg-light">
            <b-row> <!-- Satır grubu oluştur -->
              <b-col class="col-6">
                <b-form-group label="İşletme Adı :" label-for="name">
                  <b-form-input id="name" v-model="clients.name" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="col-6">
                <b-form-group label="Bakiye :" label-for="balanceText">
                  <b-form-input id="balanceText" v-model="clients.balanceText" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <!-- Kullanıcı Bilgileri -->
        <b-col class="col-6">
          <b-card header="Kullanıcı Bilgileri" class="mb-3">
            <b-form-group label="Kullanıcı Adı :" label-for="username">
              <b-form-input id="username" v-model="clients.username" required></b-form-input>
            </b-form-group>

            <b-form-group label="Şifre :" label-for="password">
              <b-input-group>
                <b-form-input
                    id="password"
                    v-model="clients.password"
                    type="text"
                    required
                ></b-form-input>
                <b-input-group-append>
                  <b-button @click="generateRandomPassword" variant="outline-secondary">
                    <b-icon icon="lightning-fill" variant="warning" class="mr-1"></b-icon>
                    Şifre Öner
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-row class="justify-content-end">
              <b-col class="col-auto">
                <b-button @click="updateUser" variant="success" :disabled="!clients.username || !clients.password">
                  <b-icon icon="plus"></b-icon> Kullanıcı Güncelle
                </b-button>
                <b-button @click="deleteUser" variant="danger" class="ml-2" v-if="this.$route.params.username">
                  <b-icon icon="trash"></b-icon> Kullanıcı Sil
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>


        <!-- Limit Bilgileri -->
        <b-col class="col-6">
          <b-card header="Bakiye Bilgileri" class="mb-3 border-warning">
            <b-form-group label="Manuel Bakiye Ekle :" label-for="balance">
              <b-input-group>
                <b-input-group-prepend is-text>₺</b-input-group-prepend>
                <b-form-input
                    id="balance"
                    type="text"
                    :value="formattedBalance"
                    @input="onInputBalance"
                    @keypress="onlyAllowNumbers"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-row class="justify-content-end">
              <b-col class="col-auto">
                <b-button @click="addBalance" variant="success" :disabled="!clients.balance">
                  <b-icon icon="plus"></b-icon> Manuel Bakiye Yükle
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card header="Eksi Bakiye Bilgileri" class="mb-3 border-warning">
            <b-form-group label="Eksi Bakiye :" label-for="balanceLimit">
              <b-input-group>
                <b-input-group-prepend is-text>₺</b-input-group-prepend>
                <b-form-input
                    id="balanceLimit"
                    type="text"
                    :value="formattedBalanceLimit"
                    @input="onInputBalanceLimit"
                    @keypress="onlyAllowNumbers"
                />
              </b-input-group>
            </b-form-group>
            <b-row class="justify-content-end">
              <b-col class="col-auto">
                <b-button @click="setLimit" variant="success" :disabled="!clients.balanceLimit">
                  <b-icon icon="plus"></b-icon> Eksi Bakiye Güncelle
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import UserService from '../../service/UserService';
import ClientService from '../../service/ClientService';
import PaymentService from "@/service/PaymentService";
export default {
    name: "update-shop",
    data() {
      return {
        clients: {
          id: this.$route.params.id,
          name: this.$route.params.name,
          username: this.$route.params.username,
          balance: undefined,
          balanceText: this.$route.params.balanceText,
          balanceLimit: this.$route.params.balanceLimit,
          limit: this.$route.params.limit
        },
        loading: false,
      };
    },
    methods: {
      generateRandomPassword() {
        this.$set(this.clients, 'password', Math.floor(100000 + Math.random() * 900000).toString());
      },
      async updateUser() {
        this.loading = true;
        if (!this.clients.username || !this.clients.password) {
          this.$alert(this, "Kullanıcı adı ve şifre boş bırakılamaz!");
          this.loading = false;
          return;
        }

        const data = {
          username: this.clients.username,
          password: this.clients.password,
          clientId: this.$route.params.id,
        };
        try {
          await UserService.register(data);
          this.$notification(this, "Kullanıcı bilgileri başarıyla güncellendi.");
        } finally {
          this.clients.password = ''
          this.loading = false;
        }
      },

      async deleteUser() {
        this.loading = true;

        const data = {
          clientId: this.$route.params.id,
        };
        try {
          await UserService.delete(data);
          this.clients.username = undefined;
          this.$notification(this, "Kullanıcı başarıyla silindi.");
        } finally {
          this.loading = false;
        }
      },

      async addBalance() {
        this.loading = true;
        if (!this.clients.balance) {
          this.$alert(this, "Bakiye boş bırakılamaz!");
          this.loading = false;
          return;
        }

        const data = {
          balance: this.clients.balance,
          clientId: this.$route.params.id,
        };
        try {
          this.clients.balanceText = await PaymentService.addBalance(data);
          this.$notification(this, "Bakiye bilgileri başarıyla güncellendi.");
        } finally {
          this.loading = false;
          this.clients.balance = undefined;
        }
      },

      async setLimit() {
        this.loading = true;
        if (!this.clients.balanceLimit) {
          this.$alert(this, "Limit boş bırakılamaz!");
          this.loading = false;
          return;
        }

        const data = {
          balanceLimit: this.clients.balanceLimit,
          clientId: this.$route.params.id,
        };
        try {
          await ClientService.setLimit(data);
          this.$notification(this, "Limit bilgileri başarıyla güncellendi.");
        } finally {
          this.loading = false;
        }
      },

      onInputBalanceLimit(value) {
        // Nokta veya virgül varsa kaldırıyoruz
        const numericValue = value.replace(/\./g, '').replace(',', '');
        this.clients.balanceLimit = numericValue ? Number(numericValue) : null;
      },
      onInputBalance(value) {
        // Nokta veya virgül varsa kaldırıyoruz
        const numericValue = value.replace(/\./g, '').replace(',', '');
        this.clients.balance = numericValue ? Number(numericValue) : null;
      },
      onlyAllowNumbers(event) {
        const charCode = event.charCode
        if (charCode < 48 || charCode > 57) {
          event.preventDefault()
        }
      },
    },
    beforeMount() {
    },
  computed: {
    // Görsel olarak gösterilen değer
    formattedBalanceLimit() {
      if (this.clients.balanceLimit == null) return '';
      // sayıyı stringe çevirip binlik ayraç ekliyoruz
      return this.clients.balanceLimit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formattedBalance() {
      if (this.clients.balance == null) return '';
      // sayıyı stringe çevirip binlik ayraç ekliyoruz
      return this.clients.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  },
  };
</script>
<style>
  img {
    max-width: 100%;
  }
</style>
